export const useListProps = (id: string | undefined) => {
  return {
    path: `/shipment-service/shipment-costs`,
    selectRowsEnabled: { enabled: false },
    actionBar: { enabled: false },
    pagination: { enabled: false },

    filters: {
      name: "shipmentCosts",
      preserve: false,

      list: [
        {
          fieldName: "shipmentId",
          hidden: true,
          value: id,
        },
      ],
    },
  };
};
